// @givmo/app-charity — this host's words for the organization's QR codes (FCM-WEB4 / PE-WEB11). The
// shared editor and the Profile page's QR card never learn whose codes they draw; these do.

/** Where a scan of the public code lands: the charity's profile (D-PE-19), one page by every route. */
export const CHARITY_PUBLIC_QR_LINE = 'People who scan this land on your public page.';

/**
 * The public code's refusal while the charity is not yet in standing for its own public target
 * (name-use standing: a CONSENTED overlay with an approved claim). "Approved" is the product's own
 * claim word.
 */
export const CHARITY_QR_TARGET_UNAVAILABLE =
  'Your QR code is available once your organization’s claim is approved and the Charity Terms are accepted.';

/** What the editor's preview is on the Profile page's QR design page. */
export const CHARITY_PUBLIC_QR_PREVIEW_NOUN = 'your public page’s code';
